import {
  CasEntityRHFSelect,
  CasEntitySelect,
  componentProps,
  CasEntitySelectProps,
} from 'src/compass/shared/components';

const entity = "Ins/CompType/Select";

export function RHFAdditCompensationSelect(props: CasEntitySelectProps) {
  return CasEntityRHFSelect(entity, props);
}

export function AdditCompensationSelect(props: componentProps) {
  return CasEntitySelect(entity, props);
}
